import { render, staticRenderFns } from "./archivesType.vue?vue&type=template&id=bd54bc06&scoped=true&"
import script from "./archivesType.vue?vue&type=script&lang=js&"
export * from "./archivesType.vue?vue&type=script&lang=js&"
import style0 from "./archivesType.vue?vue&type=style&index=0&id=bd54bc06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd54bc06",
  null
  
)

export default component.exports